<template>

    <!-- 今日上新的课程列表 -->
    <div class="page white_bg" style="max-width: 425px;">

        <header class="pageHeader white_bg lightGreyBottomBorder" style="line-height: 30px;">
            <div class="borderLayout paddingH16 paddingV8">
                <div class="middleRegion">
                    <div class="westRegion" style="width: 60px">
                        <span class="icon leftAngleBracketIcon floatL" style="margin-top: 3px;" @click="back();"></span>
                    </div>
                    <div class="centerRegion alignCenter font18r primaryTextColor bold"
                         style="height: 30px; overflow: hidden">
                        {{title}}
                    </div>
                    <div class="eastRegion font14r alignRight" style="width: 60px">

                    </div>
                </div>
            </div>
        </header>

        <div class="body" style="">
            <div class="white_bg" style="border-radius: 16px 16px 0px 0px;">

                <div class="dataList" >
                    <div class="dataRow flexLayout" v-for="(dataItem, index) in dataList"
                         :key="dataItem.id" @click="viewItem(dataItem)">
                        <div style="width: 80px;">
                            <div class="imageArea roundBorder8 hiddenOverflow w100p" style="height: 78px;">
                                <img class="fullSpace cover" :src="dataItem.coverImg" v-if="dataItem.coverImg"/>
                            </div>
                        </div>
                        <div class="flexItem marginL8">
                            <div class="lineHeight21r14f bold font14r grey20 hiddenOverflow" style="
                                height: 3em;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                -webkit-box-orient: vertical;">
                                {{dataItem.title}}
                            </div>
                            <div class="marginT12 clearfix font14r">
                                <span class="orange">到期时间：</span>
                                <span class="grey75 marginR8">{{ formatDateTime(dataItem.endTime) }}</span>

                                <span class="textLabel redTextLabel" v-if="dataItem.bizType == bizTypeEnum.DATUM.code">
                                    资料
                                </span>
                                <span class="textLabel blueTextLabel" v-if="dataItem.bizType == bizTypeEnum.VOD.code">
                                    课程
                                </span>
                                <span class="textLabel yellowTextLabel" v-if="dataItem.bizType == bizTypeEnum.ATLAS.code">
                                    图文
                                </span>
                            </div>
                        </div>
                        <div style="width: 16px">
                            <i class="icon arrowIcon relative"
                               style="width: 16px; height: 16px; top: 28px; "></i>
                        </div>
                    </div>

                    <div class="alignCenter paddingV8" v-show="status === 'loading'">
                        <i class="icon spinner-loader"></i>
                    </div>

                    <div class="paddingV16 colorCCC font14r alignC"
                         v-show="status == 'ready' && dataList.length < 1">
                        暂无任何课程
                    </div>

                    <div class="paddingV16 alignCenter font14r colorCCC"
                         v-show="status=='ready' && pagination.current == pagination.totalPage"
                         :data-current="pagination.current" :data-total="pagination.totalPage || 0">
                        没有更多课程了
                    </div>

                    <div class="paddingV16 colorCCC font14r alignC"
                         v-show="status == 'error'">
                        加载数据失败
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
import shixunPagePart from '../shixunApp/shixunPagePart';

// config and data
import appConfig    from '@/appConfig';
import bizTypeEnum  from "@data/bizTypeEnum";

import consoleApi       from '../platformApi/consoleApi';

// util
import appHelper        from '@/util/appHelper';
import numberHelper from "@util/numberHelper";
import dataMixedUtils from "@util/dataMixedUtils";
import {toDetailByBizType} from '@comp/shixunApp/toDetail';

const config = {
    name : 'agencyResource',
    title : '代理商培训中心',
    description : appConfig.name + ' - ' + appConfig.desc,
    apiConfig : {
        list : {
            url : 'portal/v2/distribution/material/list',
            dataPath : 'data',
            // totalPath : 'data.total',
            // totalPagePath : 'data.pages',
            params : {
                type : 2
            },
            dataColumnMapping : {
                // userName : 'name''
            }
        }
    }
};

export default {
    name: config.name,
    extends : shixunPagePart,
    data () {
        return {
            title : config.title,
            description : config.description,
            apiConfig : config.apiConfig,
            enableDataList : true,
            autoLoadDataList : appConfig.mode != 'demo',

            bizTypeEnum : bizTypeEnum
        }
    },
    methods : {

        viewItem(dataItem) {
            toDetailByBizType(dataItem.bizType, dataItem.id);
        }
    },
    mounted() {
        if (appConfig.mode === 'demo')
        {
            for (let i=1; i<=8; i++)
            {
                this.dataList.push({
                    id : i,
                    title : '课程名称课程名称课程名称课程名称课程名称课程名称课程名称课程名称',
                    coverImg : appHelper.getRandomCoverImage(),
                    bizType : dataMixedUtils.array.getRandomItem([2, 3, 4]),
                    endTime : new Date().getTime() + numberHelper.getRandomInteger(1000 * 60 * 60 * 24 * 7),
                    startTime : new Date().getTime() - 1000 * 7 * 3600,
                });
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.lightGrey {
    color: hsla(219, 16%, 60%, 1);
}
.grey {
    color: hsla(219, 9%, 39%, 1);
}
.orange {
    color: #F4950E;
}
.searchIcon {
    width: 18px;
    height: 19px;
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAmCAYAAABDClKtAAADVklEQVRYhcWYT4jVVRTHb00DNgYiuRUXuhAdH9zz+d6hgSf8RKQhGC3ih2U7CSIIhEJdBEK0qFaKKBptBLFoIWYgLRKhiGgSUjcTiFhBQfindPUGG2dczHvTnTu/9+b9Zt6fA2fx3r3nnM895/7uP+dKSJ7nA977ncAHkr6RdBuoAbPAbP33FUlHzewVYLCM/1ICrAM+BO40ANpRM5uS9CmwuZMwQ8CRMiAt9DNg3YqAJA0Dv7YI8kDSz5IuRnoV+LOFzUNJu5YFZGZjZjZV5BQ4I2lkCftNko4CfzSBe9s593SZDO0pcDIl6USWZavKDtB7f7g+mNTngbYcmFklzZCZ/SbJl4WJpVqtrgV+KfgQ9rY0BNYAtxPDyeVkp0WMr9Kv08w2NTWQ9EmaoU4CRXF+TOJczrLsmUUdQwjrC+bQikrWTEZHR59N1ztJe4roTyRQx7oB1BBgHzATxbuxoEOWZauSyf2wG2UrALuWZOv/ykh6NcnSmW4D1eO+k0AdiomPJ40tF8ZOCjAdxf4hJv4uLl2vgOpQ16PYNefcU42G36MsXe0x1KW4SiGE9Y2GeD5d6THUuTi+937DIihJX/cTysxwzjlnZv/2sXyfNytffGb6q5dQki7HUPPrY0I7MzIy8nyvoIC/o9i34oYDSQrf6wWQmW1PPrKT843e+y3JZO/JvJJ0MYF6eUEH4Ke4hJJe6iYQc7ej/+KFc9HxpWD/u9lNKEnfJtU5uKhTnucD9ZtIvGZ80SWgQ8mxpQasKexsZi8k2ZqR9H4ngUIIe4FHSZZeX2oUBxOwaeBUJ4CAN1Mg4Fye5wNLGQ5KOp0YzgITK1m/zOy8pOnE57VKpbK63RENAV8WgNWAC+3CjY+PD5nZSeBBga9Z4D5l3hiAQeDjJs4eAzfM7Kyk/ZKGG+q9fw04Bkyw8ADXTO9577e0Deacc2b2YrIVrERrkvYD/yT/3w0hbC0FVqlUVgPvxqeJZehH1Wp1rXPzO8j9FEzScCkw5+ZuPSGEcUnniR7KWuglM3sjy7LnUl8hhK3AvaT/HWBbabCG5Hk+AGwMIYxJ2i3pLe/97hDCmJlVXBsvKvWnprspWN2+fwJsKwD7vq9Qzs299LDwGj/Zbybn3DzYBDAJ7HgCwHW6Z9xb1m4AAAAASUVORK5CYII=');
}
.dataList {
    .dataRow {
        padding: 21px 12px 11px;
    }
    .textLabel {
        width: 34px;
        height: 24px;
        line-height: 24px;
        padding: 0;
        border-radius: 6px;
        border: none;
        color: white;
        text-align: center;
    }
}
.blueTextLabel {
    background: #61B5FD;
}
.redTextLabel {
    background: #F46C64;
}
.yellowTextLabel {
    background: #FFD411;
}
.arrowIcon {
    width: 14px;
    height: 14px;
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAABI0lEQVRIie3VrUoEYRTG8RfEIJgEQYyCiK4zzHn+74QBk8ngBdiELQb3Buwmg9FiFTGIyaDBZhGTUYtabBbxY1cWxuA7sDdwFpR9buDHwzmHE8Io/z5FUWxKWhwWtg3UwAew4g7meb4s6T2hPUlr7qgkgNeEfprZhjtqZkuSnhP6LWnLHS2KYl7SA1BL6gI77qiZzUq6TU37kvaGgU4D1w1qZofuaKvVmgQuE1pLOnFHgXFJ5w0KHLujklbTAtWSnqqqmvDE1oFuavdmZtENM7M28JWavcQYzQ2LMXaAXmr2GGNccMMk7TYzA+6yLJvzxPaBPlCb2U1ZljOe2FGDAVdVVU15YqcDB37hvfqdAewshDDmhoXw+4CBezM7cIVG+VP5AUoCdS27VAqpAAAAAElFTkSuQmCC');
}
</style>
